<template lang="pug">
  heading(v-bind="props")
    slot
</template>

<script setup>
import Heading from '/components/base/Heading.vue'
import { useDisplay } from 'vuetify'
defineOptions({
  name: 'BaseSubheading',
})

const props = defineProps({
  title: String,
  align: String,
  dense: Boolean,
  space: [Number, String],
  tag: {
    type: String,
    default: 'h1',
  },
  size: {
    type: String,
    default: 'text-h5',
  },
  mobileSize: {
    type: String,
    default: 'text-h6',
  },
  weight: {
    type: String,
    default: 'bold',
  },
})
</script>
